// const productionUrl = "https://preprod.hindustanloans.com/"; //  Prod
const productionUrl = "https://bap.hindustanloans.com/"; //  Prod
const developmentUrl = "http://localhost:3000/"; // Dev
// const developmentUrl = "http://192.168.29.178:3000/"; // Dev

const productionTip = true; // if false then development

export const hostname = productionTip ? productionUrl : developmentUrl;
